module.exports = __webpack_public_path__ + "img/yncgzh.d6108c63.png";